import { MutableRefObject, useEffect } from 'react'
import Styles from 'proseShared/plugins/Comments/Comments.module.scss'

export const useOutsideClick = (
  ref: MutableRefObject<any>,
  handleOutSideClick: (e?: any) => void,
  condition?: boolean,
) => {
  useEffect(() => {
    const handleClick = (e: Event) => {
      const el = e.target as HTMLElement

      if (ref.current && !ref.current.contains(el) && !el.classList.contains(Styles.commentIcon)) {
        handleOutSideClick(e)
      }
    }

    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [ref, handleOutSideClick, condition])
}
